import {
  $changePassword,
  $confirmEmail,
  $confirmEmailByTwilio,
  $confirmTemporary,
  $deleteAccount,
  $disableGoogleAuthenticator,
  $disableTwillio2fa,
  $enableGoogleAuthenticator,
  $generateCode,
  $getCompatibleSignedGetUrl,
  $getCurrentUser,
  $getEmbedSignedUrlBulk,
  $getSignedGetDownloadUrl,
  $getSignedGetUrl,
  $getSignedGetUrlBulk,
  $getSignedGetUrlHash,
  $getSignedPutAssetUrl,
  $getSignedPutUrl,
  $getSignersAvatars,
  $ltdSignUp,
  $putAvatar,
  $putCompanyLogo,
  $putRequisite,
  $sendConformationEmail,
  $sendPasswordChangeEmail,
  $signInAppSumoUser,
  $signInGoogleAuthenticator,
  $signInPrimary,
  $signInTwillio,
  $signOut,
  $signUp,
  $signUpFromTemporary,
  $signUpTemporary,
  $signUpWithConfirmCode,
  $signUpWithPlanPrepare,
  $subscribeOnAPIUpdates,
  $unsubscribeFromAPIUpdates,
  $updateCompanyInfo,
  $updateEmail,
  $updateGoogleClientId,
  $updateProfileInfo,
  $verifyGoogleCode,
  $verifyPhone,
  applyAppSumoLink,
  changePassword,
  changeShowPlanUpgradeSuccessPage,
  clearEmailToken,
  clearIntegrationData,
  clearPasswordToken,
  clearShowTrialSuccessPage,
  confirmEmail,
  confirmEmailByTwilio,
  confirmTemporary,
  connectSocket,
  deleteAccount,
  disableGoogleAuthenticator,
  disableTwillio2fa,
  disconnectSocket,
  enableGoogleAuthenticator,
  finishInitAccessToken,
  generateCode,
  getCompatibleSignedGetUrl,
  getCurrentUser,
  getEmbedSignedUrlBulk,
  getSignedGetDownloadUrl,
  getSignedGetUrl,
  getSignedGetUrlBulk,
  getSignedPutAssetUrl,
  getSignedPutUrl,
  getSignersAvatars,
  initAccessToken,
  joinSocketRoom,
  logout,
  ltdSignUp,
  putCompanyLogo,
  putRequisite,
  sendConformationEmail,
  sendPasswordChangeEmail,
  setEmailConfirmationData,
  setEmailToken,
  setIsEmailConfirmed,
  setPasswordToken,
  setTwoFactor,
  setUnauthorized,
  signIn,
  signInAppSumoUser,
  signInGoogleAuthenticator,
  signInPrimary,
  signInTwillio,
  signUp,
  signUpFromTemporary,
  signUpTemporary,
  subscribeOnAPIUpdates,
  unsubscribeFromAPIUpdates,
  updateCompanyInfo,
  updateEmail,
  updateGoogleClientId,
  updateProfileInfo,
  verifyGoogleCode,
  verifyPhone,
} from './actionCreators';
import reducer from './reducer';
import sagas from './sagas';

export default {
  sagas,
  reducer,
  actions: {
    signIn,
    setTwoFactor,
    enableGoogleAuthenticator,
    disableGoogleAuthenticator,
    verifyGoogleCode,
    signInPrimary,
    signInTwillio,
    signInGoogleAuthenticator,
    signUp,
    setEmailConfirmationData,
    logout,
    verifyPhone,
    generateCode,
    getSignedGetUrl,
    getCompatibleSignedGetUrl,
    getSignedPutUrl,
    getSignedGetDownloadUrl,
    updateCompanyInfo,
    putCompanyLogo,
    putRequisite,
    deleteAccount,
    getCurrentUser,
    disableTwillio2fa,
    updateProfileInfo,
    getSignedPutAssetUrl,
    connectSocket,
    disconnectSocket,
    setUnauthorized,
    joinSocketRoom,
    sendPasswordChangeEmail,
    changePassword,
    setPasswordToken,
    clearPasswordToken,
    getSignedGetUrlBulk,
    subscribeOnAPIUpdates,
    confirmEmail,
    confirmEmailByTwilio,
    sendConformationEmail,
    unsubscribeFromAPIUpdates,
    setEmailToken,
    clearEmailToken,
    signInAppSumoUser,
    applyAppSumoLink,
    getSignersAvatars,
    updateEmail,
    setIsEmailConfirmed,
    initAccessToken,
    finishInitAccessToken,
    updateGoogleClientId,
    getEmbedSignedUrlBulk,
    clearIntegrationData,
    ltdSignUp,
    signUpTemporary,
    signUpFromTemporary,
    confirmTemporary,
    clearShowTrialSuccessPage,
    changeShowPlanUpgradeSuccessPage,
  },
};

export const $actions = {
  signInPrimary: $signInPrimary,
  signInTwillio: $signInTwillio,
  signInGoogleAuthenticator: $signInGoogleAuthenticator,
  updateEmail: $updateEmail,
  signUp: $signUp,
  signUpTemporary: $signUpTemporary,
  signUpFromTemporary: $signUpFromTemporary,
  confirmTemporary: $confirmTemporary,
  ltdSignUp: $ltdSignUp,
  getSignersAvatars: $getSignersAvatars,
  changePassword: $changePassword,
  confirmEmail: $confirmEmail,
  confirmEmailByTwilio: $confirmEmailByTwilio,
  sendConformationEmail: $sendConformationEmail,
  getSignedGetUrl: $getSignedGetUrl,
  getCompatibleSignedGetUrl: $getCompatibleSignedGetUrl,
  getSignedGetUrlHash: $getSignedGetUrlHash,
  getSignedPutAssetUrl: $getSignedPutAssetUrl,
  verifyPhone: $verifyPhone,
  enableGoogleAuthenticator: $enableGoogleAuthenticator,
  disableGoogleAuthenticator: $disableGoogleAuthenticator,
  verifyGoogleCode: $verifyGoogleCode,
  generateCode: $generateCode,
  putCompanyLogo: $putCompanyLogo,
  putAvatar: $putAvatar,
  disableTwillio2fa: $disableTwillio2fa,
  updateCompanyInfo: $updateCompanyInfo,
  getSignedGetDownloadUrl: $getSignedGetDownloadUrl,
  deleteAccount: $deleteAccount,
  updateProfileInfo: $updateProfileInfo,
  getSignedPutUrl: $getSignedPutUrl,
  putRequisite: $putRequisite,
  signOut: $signOut,
  getCurrentUser: $getCurrentUser,
  sendPasswordChangeEmail: $sendPasswordChangeEmail,
  getSignedGetUrlBulk: $getSignedGetUrlBulk,
  subscribeOnAPIUpdates: $subscribeOnAPIUpdates,
  unsubscribeFromAPIUpdates: $unsubscribeFromAPIUpdates,
  signInAppSumoUser: $signInAppSumoUser,
  signUpWithPlanPrepare: $signUpWithPlanPrepare,
  signUpWithConfirmCode: $signUpWithConfirmCode,
  updateGoolgeClientId: $updateGoogleClientId,
  getEmbedSignedUrlBulk: $getEmbedSignedUrlBulk,
};
